<template>
  <div>
    <b-form v-if="userInfo">
      <b-card style="margin: 1%">
        <b-row>
          <b-col md="1" cols="0" xl="1"/>
          <b-col md="10" cols="12" xl="10" >
            <b-form-group label-align="right" v-for="userAddParam in userInfo.additional_params" v-bind:key="userAddParam.id" label-cols="4" label-cols-xl="4" label-cols-md="4" :label="userAddParam.display_name" >
              <b-form-input type="text" v-model="userAddParam.value"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: null
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additional/main.vue